import PropTypes from 'prop-types';

const displayName = 'Loading';
const propTypes = {
  isLoading: PropTypes.bool,
};
const defaultProps = {
  isLoading: false,
};

export default { propTypes, defaultProps, displayName };
